// react
import React, { useState, useContext } from "react";

// react-router-dom
import { useNavigate } from "react-router-dom";

// axios
import axios from "axios";

// mui
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

// components
import Snackbar from "../../components/snackbar/snackbarComponent";
import Footer from "../../components/footer/footerComponent";
import Navbar from "../../components/navbar/navbarComponent";

// context
import { SnackbarContext } from "../../Context/snackbarContext/snackbarContext";

// images
import HomeImage from "../../assets/home.svg";

// styles
import useStyles from "./homeStyles";
import { Box } from "@mui/material";

// Home-Component
const Home = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const bodyUrl = process.env.REACT_APP_ACTIVATION_MID_URL;
  const classes = useStyles();
  const [edgeEUI, setEdgeEUI] = useState("");
  const { setSnackbarData } = useContext(SnackbarContext);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
 
  const handleSubmit = (e) => {
    setIsLoading(false);
    setSnackbarData(true);
    if (edgeEUI == "") {
      setSnackbarData({
        message: "Please enter device EUI.",
        severity: "warning",
        open: true,
      });
    } else {
      setIsLoading(true);
      axios
        .get(`${baseUrl}/${bodyUrl}${edgeEUI}`)
        .then((data) => {
          if (data.status == 200) {
            setIsLoading(false);
            navigate(`/${edgeEUI}`);
          }
        })
        .catch((err) => {
          setIsLoading(false);
          if (err.response.status === 404) {
            setSnackbarData({
              message: "Invalid Edge EUI.",
              severity: "error",
              open: true,
            });
          } else {
            setSnackbarData({
              message: "Something went wrong.",
              severity: "error",
              open: true,
            });
          }
        });
    }
  };

  const handleKeyPress = (e) => {
    var key = e.key;
    if(e.key === 'Enter')
    {
      handleSubmit();
    }
 }

  return (
    <>
      {/* navbar */}
      <Navbar title="Fogwing Device Activation" />

      {/* main content */}
      <Box className={classes.mainContent} sx = {{ marginTop : {xs : '4.5rem',md : '3.5rem'}}}>
        {/* banner image */}
        <div className={classes.image}>
          <img src={HomeImage} style={{ width: 300 }} alt="website logo" />
        </div>

        <div className={classes.text}>
          <p style={{ fontWeight: "bold", fontSize: 14 }}>
            Enter device EUI to select and activate.
          </p>
        </div>
        <div className={classes.edgeEUIField}>
          <TextField
            style={{ width: 300 }}
            className={classes.textField}
            name="edgeEUI"
            value={edgeEUI}
            id="outlined-basic"
            size="small"
            label="Enter Device EUI"
            variant="outlined"
            onChange={(e) => {
              setEdgeEUI(e.target.value);
            }}
            InputProps={classes.textField}
            onKeyPress = {(e) => handleKeyPress(e)}
          />
        </div>

        <div className={classes.button}>
          <button
            type="button"
            className="btn btn-outline-primary"
            disabled={isLoading}
            onClick={handleSubmit}
          >
            {isLoading ? "Loading..." : "Submit"}
          </button>
        </div>
      </Box>

      {/* snackbar */}
      <Snackbar key={Date.now()} />

      {/* footer */}
      <Footer />
    </>
  );
};

export default Home;
